export default {
  locale: "es",
  name: "CancellationPoliciesconfiguration",
  translation: { displayName: "Configurar la pregunta" },
  fields: {
    /** Here are te entities used in the lists, Order is important */
    /** fieldName: this is used like the id container of the properties */
    /** displayName: this is the title rendered */
    list: [
      //columns to be used in the table/list display, Order IS important
      {
        fieldName: "position",
        displayName: "Orden",
      },
      {
        fieldName: "active",
        displayName: "Activo",
      },
      {
        fieldName: "ticker",
        displayName: "Identificador",
      },
      {
        fieldName: "widgetType",
        fieldSelector: {
          INPUT: "Texto libre",
          SELECT: "Desplegable",
          STAY_DATE: "Selector día estancia",
          CHECKBOX: "Checkbox",
          PHONE: "Teléfono",
        },
        displayName: "Tipo de respuesta ",
      },
      {
        fieldName: "required",
        displayName: "Obligatorio",
      },
    ],
    form: [
      //fields to be used in the creation/edit form display, Order IS important
      {
        fieldName: "position",
        widget: "hidden",
      },
      {
        fieldName: "active",
        displayName: "Activo",
        widget: "singleSwitch",
        className: "activeCheckbox",
      },
      {
        fieldName: "ticker",
        displayName: "Identificador",
        widget: "input",
        className: "tickerInput",
      },
      {
        fieldName: "required",
        displayName: "Obligatorio",
        widget: "checkbox",
      },
      {
        fieldName: "widgetType",
        displayName: "Tipo de respuesta",
        widget: "selector",
        optionDisplay: {
          INPUT: {
            label: "Texto libre",
          },
          SELECT: {
            label: "Desplegable",
          },
          // CHECKBOX: {
          //   label: "Checkbox"
          // },
          STAY_DATE: {
            label: "Selector día estancia",
          },
          PHONE: {
            label: "Teléfono",
          },
        },
        defaultValue: "INPUT",
      },
      {
        fieldName: "label",
        displayName: "Pregunta",
        widget: "input",
        className: "tickerInput",
        translated: true,
      },
      {
        fieldName: "placeholder",
        widget: "input",
        displayName: "Información de ayuda sobre el campo",
        className: "tickerInput",
        translated: true,
      },
      {
        fieldName: "items",
        displayName: "Opciones de respuesta",
        placeholder: "opcion1,opcion2,opcion3...",
        widget: "input",
        translated: true,
        visible: ({ formValues }) =>
          formValues.widgetType === "SELECT" || formValues.widgetType === "CHECKBOX",
      },
    ],
  },
};
